import React, { useState, useMemo } from 'react';

interface ConfirmationStepProps {
  clientName: string;
  setClientName: (name: string) => void;
  clientPhone: string | null;
  setClientPhone: (phone: string | null) => void;
  clientEmail: string | null;
  setClientEmail: (email: string | null) => void;
  consent: boolean;
  setConsent: (consent: boolean) => void;
  errors: {
    clientName?: string;
    consent?: string;
  };
}

export default function ConfirmationStep({
  clientName,
  setClientName,
  clientPhone,
  setClientPhone,
  clientEmail,
  setClientEmail,
  consent,
  setConsent,
  errors
}: ConfirmationStepProps) {

  return (

    <div style={{
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Decorative background elements */}
      <div style={{
        position: "absolute",
        top: "-50px",
        right: "-50px",
        width: "200px",
        height: "200px",
      }} />
      <div style={{
        position: "absolute",
        bottom: "-30px",
        left: "-30px",
        width: "150px",
        height: "150px",
      }} />


      {/* Content Section */}
      <div style={{
        display: "grid",
        gap: "32px",
        position: "relative",
        zIndex: 1
      }}>
        {/* Client Data Card */}
        <div style={{
          background: "#ffffff",
          borderRadius: "16px",
          padding: "32px",
          border: "1px solid #e5e7eb",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)"
        }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "24px",
            paddingBottom: "16px",
            borderBottom: "2px solid #f3f4f6"
          }}>
            <h3 style={{
              fontSize: "20px",
              fontWeight: 600,
              color: "#1f2937",
              margin: 0
            }}>
              Klientendaten
            </h3>
          </div>

          <div className="task-form-group" style={{ marginBottom: "24px" }}>
            <label className="task-form-label" htmlFor="csClientName" style={{
              display: "block",
              fontWeight: 600,
              marginBottom: "8px",
              color: "#374151",
              fontSize: "14px"
            }}>
              Klient *
            </label>
            <input
              id="csClientName"
              className="task-form-input"
              type="text"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              style={{
                width: "100%",
                padding: "16px 20px",
                border: "2px solid #e5e7eb",
                borderRadius: "12px",
                fontSize: "16px",
                transition: "all 0.3s ease",
                background: "#f9fafb"
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#98c44c";
                e.target.style.background = "#ffffff";
                e.target.style.boxShadow = "0 0 0 3px rgba(152, 196, 76, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e5e7eb";
                e.target.style.background = "#f9fafb";
                e.target.style.boxShadow = "none";
              }}
            />
            {errors.clientName && (
              <div style={{
                color: "#e74c3c",
                fontSize: "14px",
                marginTop: "8px",
                display: "flex",
                alignItems: "center",
                gap: "6px"
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                {errors.clientName}
              </div>
            )}
          </div>

          <div className="task-form-two-col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            <div className="task-form-group">
              <label className="task-form-label" htmlFor="csPhone" style={{
                display: "block",
                fontWeight: 600,
                marginBottom: "8px",
                color: "#374151",
                fontSize: "14px"
              }}>
                Telefon
              </label>
              <div style={{ position: "relative" }}>
                <div style={{
                  position: "absolute",
                  left: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6b7280"
                }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                  </svg>
                </div>
                <input
                  id="csPhone"
                  className="task-form-input"
                  type="tel"
                  value={clientPhone ?? ""}
                  onChange={(e) => setClientPhone(e.target.value || null)}
                  placeholder="z. B. 0157…"
                  style={{
                    width: "100%",
                    padding: "16px 20px 16px 48px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "12px",
                    fontSize: "16px",
                    transition: "all 0.3s ease",
                    background: "#f9fafb"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#4d8ba5";
                    e.target.style.background = "#ffffff";
                    e.target.style.boxShadow = "0 0 0 3px rgba(77, 139, 165, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e5e7eb";
                    e.target.style.background = "#f9fafb";
                    e.target.style.boxShadow = "none";
                  }}
                />
              </div>
            </div>
            <div className="task-form-group">
              <label className="task-form-label" htmlFor="csEmail" style={{
                display: "block",
                fontWeight: 600,
                marginBottom: "8px",
                color: "#374151",
                fontSize: "14px"
              }}>
                E-Mail
              </label>
              <div style={{ position: "relative" }}>
                <div style={{
                  position: "absolute",
                  left: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6b7280"
                }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </div>
                <input
                  id="csEmail"
                  className="task-form-input"
                  type="email"
                  value={clientEmail ?? ""}
                  onChange={(e) => setClientEmail(e.target.value || null)}
                  placeholder="z. B. name@mail.de"
                  style={{
                    width: "100%",
                    padding: "16px 20px 16px 48px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "12px",
                    fontSize: "16px",
                    transition: "all 0.3s ease",
                    background: "#f9fafb"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#4d8ba5";
                    e.target.style.background = "#ffffff";
                    e.target.style.boxShadow = "0 0 0 3px rgba(77, 139, 165, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e5e7eb";
                    e.target.style.background = "#f9fafb";
                    e.target.style.boxShadow = "none";
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Consent Card */}
        <div style={{
          background: "#fff",
          borderRadius: "16px",
          padding: "32px",
          border: "1px solid #dcdcdcdd",
          boxShadow: "0 4px 12px rgba(251, 191, 36, 0.15)"
        }}>
          <div style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "16px",
            marginBottom: "20px"
          }}>
            <div style={{
              width: "48px",
              height: "48px",
              background: "linear-gradient(135deg, #0bb7f5ff 0%, #96d906ff 100%)",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              flexShrink: 0
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </div>
            <div style={{ flex: 1 }}>
              <h3 style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#333",
                margin: "0 0 8px 0"
              }}>
                Einwilligung des Klienten
              </h3>
              <p style={{
                fontSize: "14px",
                color: "#333",
                margin: 0,
                lineHeight: "1.5"
              }}>
                Für die Verarbeitung und Weiterleitung der Daten benötigen wir die ausdrückliche Einwilligung des Klienten.
              </p>
            </div>
          </div>

          <div className="task-form-group">
            <label className="task-form-checkbox" style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              cursor: "pointer",
              padding: "20px",
              background: "rgba(255, 255, 255, 0.5)",
              borderRadius: "12px",
              border: "2px solid transparent",
              transition: "all 0.3s ease"
            }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#94f50bff";
                e.currentTarget.style.background = "rgba(255, 255, 255, 1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "transparent";
                e.currentTarget.style.background = "rgba(255, 255, 255, 1)";
              }}>
              <input
                type="checkbox"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
                style={{
                  width: "20px",
                  height: "20px",
                  marginTop: "2px",
                  accentColor: "#88bc8cff"
                }}
              />
              <span style={{
                fontSize: "14px",
                color: "#333",
                lineHeight: "1.6",
                flex: 1
              }}>
                Der Klient hat zugestimmt, dass die Verbund&nbsp;Pflegehilfe zur Bedarfsklärung kontaktiert und die
                Daten entsprechend weitergeleitet werden. Die Einrichtung übernimmt die Verantwortung für die korrekte
                Einholung der Einwilligung.
              </span>
            </label>
            {errors.consent && (
              <div style={{
                color: "#dc2626",
                fontSize: "14px",
                marginTop: "12px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                background: "rgba(220, 38, 38, 0.1)",
                padding: "12px 16px",
                borderRadius: "8px"
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                {errors.consent}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>

  );
}